<template>
  <div class="tabbar-container">
    <div class="tabbar-item">
      <base-icon name="home" class="icon" />
      <span class="tit">首页</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabbar',
  components: {},
  data() {
    return {
      show: {
        type: Boolean,
        defalut: false,
      },
    };
  },
  computed: {},
  methods: {},
}

</script>
<style lang='less' scoped>
.tabbar-container {
  width: 100%;
  background: #fff;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #f1f2f6;
  height: 100px;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
  .tabbar-item {
    .icon {
      height: 48px;
      width: 48px;
    }
  }
}
</style>